import { createAsyncThunk } from '@reduxjs/toolkit';
import { getActiveChats, getChatAgents, claimJobChat as claimJobChatApi } from 'util/Api';

export const fetchJobChatDetails = createAsyncThunk(
  'candidate/getActiveChats',
  async ({ pageNumber, itemsPerPage, sort }, { rejectWithValue }) => {
    try {
      return await getActiveChats({ pageNumber, itemsPerPage, sort });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchUnclaimedChats = createAsyncThunk(
  'candidate/fetchUnclaimedChats',
  async ({ filters }, { rejectWithValue }) => {
    try {
      return await getActiveChats({ filters });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchJobChatLiveAgentDetails = createAsyncThunk(
  'candidate/getChatAgents',
  async ({ customerId, pageNumber, itemsPerPage, sort }, { rejectWithValue }) => {
    try {
      return await getChatAgents({ customerId, pageNumber, itemsPerPage, sort });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const claimJobChat = createAsyncThunk(
  'candidate/claimJobChat',
  async ({ jobChatUuid, chatId }, { rejectWithValue }) => {
    try {
      return await claimJobChatApi({ jobChatUuid, chatId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
